import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { ComponentsModule } from '../components/components.module';
import { ProcessoAssuntoService } from './processo-assunto.service';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule
  ],
  declarations: [],
  providers: [
    ProcessoAssuntoService
  ]
})
export class ProcessoAssuntoModule { }